 //export const COMMON_URL="http://10.10.0.88:8310/jnbnivas/";
//LIVE
export const COMMON_URL="https://jnbnivasb.apcfss.in/";
//export const COMMON_URL="http://172.16.150.48:8310/jnbnivas/";